import { compose } from 'redux';
import withTheme from '@material-ui/styles/withTheme';
import GoogleMapReact from 'google-map-react';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { getFacilityLocation } from 'features/facilities/facilities.actions';
import FacilityMapLocation from './FacilityMapLocation';
import { useCurrentOrganizationMapZoomLevel, useCurrentUserOrganizationLocationDefaultNordway } from 'app/hooks/useCurrentUser';

export const GoogleMapFacilityOverview = ({
  theme,
  children,
  facilityId,
  ...rest
}) => {
  const dispatch = useDispatch();
  const [location, setLocation] = useState(null);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const currentUserOrganizationLocation = useCurrentUserOrganizationLocationDefaultNordway();
  const {mapZoomLevel} = useCurrentOrganizationMapZoomLevel();
  
  useEffect(() => {
    dispatch(getFacilityLocation(facilityId)).then((payload) => {
      setLocation([payload.locationNorthSouth, payload.locationEastWest]);
      setLat(payload.locationNorthSouth);
      setLng(payload.locationEastWest);
    });
  }, [dispatch, facilityId]);

  return (
    <GoogleMapReact
      clusterRadius={1}
      defaultCenter={currentUserOrganizationLocation}
      bootstrapURLKeys={{ key: 'AIzaSyBQQk_PZzLUCixr_M6FBW2Yg6y9b5lnHI4' }}
      center={location}
      zoom={mapZoomLevel}
      {...rest}
    >
      <FacilityMapLocation lat={lat} lng={lng} />
    </GoogleMapReact>
  );
};

export default compose(withTheme)(GoogleMapFacilityOverview);
